export class UserUpdRequest{
    user: string;
    s_ins: number;
    s_cont: number;
    cix: number;
    opc: number;
    name: string;
    phone: string;
    tag_ind: string;
    tag_num: string;
    key_code: string;
    user_on_keypad: string;
    appuser_ind: string;
    remctrl_ind: string;
    remctrl_num: string;
    panic_code: string;
    key_code_ind: string;
    panic_code_ind: string;
    app_name: string;
    user_email: string;

    constructor(user: string, s_ins: number, opc: number, name: string,
        phone: string, tag_ind: string, tag_num: string, key_code: string, user_on_keypad: string,
        appuser_ind: string, remctrl_ind: string, remctrl_num: string, panic_code: string, key_code_ind: string,
        panic_code_ind: string, app_name: string, user_email: string, s_cont?: number, cix?: number){
            this.user = user;
            this.s_ins = s_ins;
            this.s_cont = s_cont;
            this.cix = cix;
            this.opc = opc;
            this.name = name;
            this.phone = phone;
            this.tag_ind = tag_ind;
            this.tag_num = tag_num;
            this.key_code = key_code;
            this.user_on_keypad = user_on_keypad;
            this.appuser_ind = appuser_ind;
            this.remctrl_ind = remctrl_ind;
            this.remctrl_num = remctrl_num;
            this.panic_code = panic_code;
            this.key_code_ind = key_code_ind;
            this.panic_code_ind = panic_code_ind;
            this.app_name = app_name;
            this.user_email = user_email;
    }
}